// extracted by mini-css-extract-plugin
module.exports = {"accord":"accord_accord__29RIG","title":"accord_title__2ZCv8","cross":"accord_cross__258C9","top":"accord_top__1wMHE","down":"accord_down__FYQX7","body":"accord_body__3M75r"};